import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { addAuthHeaders, apiPath } from '../../shared/api';
import { config } from '../../shared/config/transport';

// Define a service using a base URL and expected endpoints
export const tbnApi = createApi({
  reducerPath: 'tbn',
  baseQuery: fetchBaseQuery({
    baseUrl: apiPath(config, '/call'),
    prepareHeaders: (h) => addAuthHeaders(config, h), // Adds msal auth headers
  }),
  endpoints: (builder) => ({
    call: builder.mutation<void, string>({
      query: (body) => ({
        method: 'POST',
        url: '',
        body,
        headers: { 'Content-Type': 'application/json' },
      }),
    }),
  }),
});

export default tbnApi.reducer;

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useCallMutation: useMakeCall } = tbnApi;
